import $ from 'jquery';

let cffShowLess = $(".cff-less");
let cffShowMore = $(".cff-more");
let html = $("html");
let cffExpand = $(".cff-expand");

console.log(cffShowLess);
cffShowLess.each(function(){
    $(this).css('display', 'flex');
    $(this).hide();

    if(html.attr("lang") == "sk")
        $(this).html("Zobraziť menej");
});
cffShowMore.each(function(){
    if(html.attr("lang") == "sk")
        $(this).html("Zobraziť viac");
});

cffExpand.each(function(){
    $(this).contents().filter(function(){
        return (this.nodeType == 3);
    }).remove();
});